import { useState } from "react";
import { TransactionDetailsModal } from "./Modal/TransactionDetailsModal";

export const PurchaseTable = ({ purchases }: { purchases: any[] }) => {
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleRowClick = (purchase: any) => {
    const mockItemsDetails = [
      {
        name: "Call of Duty: Mobile",
        username: "Darklordnathan",
        image: "/images/COD.png",
        currency_amount: "200 CP",
        price: "₦1,000",
      },
      {
        name: "PUBG Mobile UC",
        username: "Darklordnathan",
        image: "/images/PUBG.jpeg",
        currency_amount: "60 UC",
        price: "₦500",
      },
      {
        name: "Clash of Clans",
        username: "Darklordnathan",
        image: "/images/COD.png",
        currency_amount: "60 Gems",
        price: "₦500",
      },
    ];

    // Create an enhanced purchase object with more details for the modal
    const enhancedPurchase = {
      ...purchase,
      items_details: mockItemsDetails,
      subtotal: "12,000",
      fee: "100",
      total: "2,100",
      coin_amount: "32",
    };

    setSelectedTransaction(enhancedPurchase);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="flex flex-col mt-10">
      <div className="overflow-x-auto">
        <table className="w-full border border-[#FFFFFF1A] rounded-2xl overflow-hidden">
          <thead>
            <tr className="bg-gray-100 dark:bg-[#FFFFFF1A] text-gray-600 dark:text-white uppercase text-xs bp:text-sm leading-normal h-[50px]">
              <th className="px-6 text-left">Order#</th>
              <th className="px-6 text-left ">Date</th>
              <th className="px-6 text-left ">Time</th>
              <th className="px-6 text-left ">Status</th>
              <th className="px-6 text-left">Items</th>
              <th className="px-6 text-left">Amount</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 dark:text-white text-xs bp:text-sm">
            {purchases.map((purchase) => (
              <tr
                key={purchase.id}
                className="border-b border-gray-200 h-[50px] hover:bg-gray-100 dark:hover:bg-[#FFFFFF0A] cursor-pointer"
                onClick={() => handleRowClick(purchase)}
              >
                <td className="px-6">{purchase.id}</td>
                <td className="px-6 ">{purchase.date}</td>
                <td className="px-6 ">{purchase.time}</td>
                <td className="px-6 ">
                  <span
                    className={`px-2 py-1 rounded text-sm font-medium ${
                      purchase.status === "Pending"
                        ? "text-orange-500"
                        : purchase.status === "Successful"
                        ? "text-green-500"
                        : purchase.status === "Reversed"
                        ? "text-blue-500"
                        : "text-red-500"
                    }`}
                  >
                    {purchase.status}
                  </span>
                </td>
                <td className="px-6">{purchase.items}</td>
                <td className="px-6 font-bold">{purchase.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center border-t border-[#FFFFFF1A]">
        <button className="border border-[#D0D5DD] dark:border-[#FFFFFF1A] px-4 py-2 rounded-md text-xs bp:text-sm dark:text-white dark:bg-[#FFFFFF1A]">
          Previous
        </button>
        <span className="text-gray-600 dark:text-white text-xs bp:text-sm">
          Page 1 of 10
        </span>
        <button className="border border-[#D0D5DD] dark:border-[#FFFFFF1A] px-4 py-2 rounded-md text-xs bp:text-sm dark:text-white dark:bg-[#FFFFFF1A]">
          Next
        </button>
      </div>

      {/* Transaction Details Modal */}
      <TransactionDetailsModal
        isOpen={isModalOpen}
        onClose={closeModal}
        transaction={selectedTransaction}
      />
    </div>
  );
};
